import { Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { BackupGuard } from './guards/backup.guard';
import { OrdenesTrabajoDetalleResolver } from './pages/ordenes-trabajo-detalle/ordenes-trabajo-detalle.resolver';
import { UnsavedChangesGuard } from './guards/unsaved-changes.guard';

export const routes: Routes = [
  {
    // Nodo raíz sin path propio: envuelve TODAS las rutas de la app para que
    // BackupGuard, vía canActivateChild, se dispare en cualquier navegación
    // (incluidas las de entre hermanos) sin tener que añadirlo ruta a ruta.
    path: '',
    canActivateChild: [BackupGuard],
    children: [
      {
        path: '',
        canActivate: [AuthGuard],
        children: [
          {
            path: '',
            pathMatch: 'full',
            redirectTo: '/home'
          },
          {
            path: 'home',
            loadComponent: () => import('./pages/home/home.page').then( m => m.HomePage)
          },
          {
            path: 'inspecciones-list',
            loadComponent: () => import('./pages/inspecciones-list/inspecciones-list.page').then( m => m.InspeccionesListPage)
          },
          {
            path: 'inspecciones-debug-list',
            loadComponent: () => import('./pages/inspecciones-debug-list/inspecciones-debug-list.page').then( m => m.InspeccionesDebugListPage)
          },
          {
            path: 'ordenes-trabajo',
            loadComponent: () => import('./pages/ordenes-trabajo/ordenes-trabajo.page').then( m => m.OrdenesTrabajoPage)
          },
          {
            path: 'ordenes-trabajo-detalle/:id',
            resolve: {
              ordenTrabajo: OrdenesTrabajoDetalleResolver
            },
            canDeactivate: [UnsavedChangesGuard],
            loadComponent: () => import('./pages/ordenes-trabajo-detalle/ordenes-trabajo-detalle.page').then( m => m.OrdenesTrabajoDetallePage)
          },
          {
            path: 'test-camera',
            loadComponent: () => import('./pages/test-camera/test-camera.page').then( m => m.TestCameraPage)
          },
          {
            path: 'perfil-usuario',
            loadComponent: () => import('./pages/perfil-usuario/perfil-usuario.page').then( m => m.PerfilUsuarioPage)
          },
          {
            path: 'gestion-datos/gestion-datos',
            loadComponent: () => import('./pages/gestion-datos/gestion-datos/gestion-datos.page').then( m => m.GestionDatosPage)
          },
          {
            path: 'gestion-datos/solicitud-acceso',
            loadComponent: () => import('./pages/gestion-datos/solicitud-acceso/solicitud-acceso.page').then( m => m.SolicitudAccesoPage)
          },
          {
            path: 'gestion-datos/validacion-otp',
            loadComponent: () => import('./pages/gestion-datos/validacion-otp/validacion-otp.page').then( m => m.ValidacionOtpPage)
          },
        ]
      },
      {
        path: 'login',
        loadComponent: () => import('./pages/login/login.page').then( m => m.LoginPage)
      },
      {
        path: 'preview-inspeccion',
        loadComponent: () => import('./pages/preview-inspeccion/preview-inspeccion.page').then( m => m.PreviewInspeccionPage)
      },
      {
        path: 'subir-fotos-inspeccion',
        loadComponent: () => import('./pages/subir-fotos-inspeccion/subir-fotos-inspeccion.page').then( m => m.SubirFotosInspeccionPage)
      },
      {
        path: 'inspecciones-debug-list',
        loadComponent: () => import('./pages/inspecciones-debug-list/inspecciones-debug-list.page').then( m => m.InspeccionesDebugListPage)
      },
      {
        path: 'escanear-qr-subir-fotos',
        loadComponent: () => import('./pages/escanear-qr-subir-fotos/escanear-qr-subir-fotos.page').then( m => m.EscanearQrSubirFotosPage)
      },
    ]
  }
];
